import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { BehaviorSubject } from 'rxjs';
import { AppService } from './app.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
	providedIn: 'root'
})
export class UserService {

	user: User | null = null;

	orgIdKey = 'orgId';

	authSet = false;

	_authSet = new BehaviorSubject(false);

	ipAddress: any

	constructor(private afs: AngularFirestore,	public auth: AngularFireAuth, private appService: AppService, private http: HttpClient) {

	}
	

	async validateUser(state: User, orgId?: number) {
		debugger
		if (!state) {
			console.log('validate user no state');
			return this.logout();
		}

		let orgIdSaved;

		if (!orgId) {
			orgIdSaved = localStorage.getItem(this.orgIdKey);
			console.log('orgIdSaved', orgIdSaved);
			orgId = Number(orgIdSaved);
		}

		if (!orgId) {
			this.appService.longMessage(`Invalid Org Id: ` + orgIdSaved);
			return this.logout();
		}

		let user: User = {
			uid: state.uid,
			user_id: '',
			lastLoginAt: state.lastLoginAt,
			email: state.email,
			emailVerified: state.emailVerified,
			is_active: false,
			contact: {},
			org_id: orgId,
			orgName: '',
			name: '',
			access_level:[]
		};

		const infos = (await this.afs.collection<User>('user', ref => {
			return ref.where('user_uid', '==', user!.uid)
				.where('org_id', '==', orgId)
				.limit(1)
		}).get().toPromise());

		if (!infos || infos.docs.length === 0) {
			this.appService.longMessage(`User ${user.email} not associated to Org Id: ` + orgId);
			this.logout();
			return;
		}

		const orgs = (await this.afs.collection<Organization>('organization', ref => {
			return ref.where('org_id', '==', orgId)
				.limit(1)
		}).get().toPromise());

		user.orgName = orgs.docs[0].data().name+' ('+user.org_id+')'
		user = Object.assign(user, infos.docs[0].data());
		user.name = user.contact!.first_name + ' ' + user.contact!.last_name;
		user.access_level=user.access_level;
		this.user = user;

		this.authSet = true;
		this._authSet.next(this.user != null);

		return this.user;
	}


	getIpAddress() {
		
		return  this.ipAddress;
	}

	isAuthenticated() {
		return this.user != null;
	}

	isAuthSet() {
		return this.authSet;
	}

	getOrgId() {
		if (this.user) {
			return this.user.org_id + '';
		}
		return '';
	}

	getUserId() {
		if (this.user) {
			return this.user.user_id;
		}
		return '';
	}
	getAccess() {
		
		if (this.user) {
			var str=''
			this.user.access_level.forEach(element => {
				str = str+element+','
			});
			return str;
		}
		return '';
	}
	async getAnimalActivityDB(){
	
		const res = await this.http.request<AnimalActivityResponse>('post', environment.serverUrl + '/get_document/dumpall', {
			
			params: {
					org_id:localStorage.getItem(this.orgIdKey)+'',
					collection: 'metadata_lims_master',
					
			}
		}).toPromise();
	
		
		
		return res.all_data[0].metadata_list;
	}

	async login(email: string, password: string, orgId: number) {
		console.log('login', email, password, orgId);
		localStorage.setItem(this.orgIdKey, orgId + '');
		await this.auth.signInWithEmailAndPassword(email, password);
	}

	async resetPassword(email: string, orgId: number) {
	//	console.log('resetPassword', email, orgId);
		localStorage.setItem(this.orgIdKey, orgId + '');
		await this.auth.sendPasswordResetEmail(email);
		
	}
	async registerUser(email: string, password: string){
		
		
		const newUser=	this.auth.createUserWithEmailAndPassword(email, password);
		debugger
		// .then((data) => {
		// 	// Signed up 
		// 	console.log('uid',data.user)
		// 	if(data.user){
		// 		console.log('uid',data.user.uid)
		// 	}
		// 	// ...
		//   }).catch(function(error) {
		//   alert(error)
		// });

	}
	

	async logout() {
		this.user = null;
		localStorage.removeItem(this.orgIdKey);
		await this.auth.signOut();
		this.authSet = true;
		return this.user;
	}
}

export interface User {
	org_id: number;
	user_id: string;
	email: string
	uid: string;
	lastLoginAt: string,
	emailVerified: boolean,
	is_active: boolean;
	orgName: string;
	name: string;
	contact: {
		email?: string;
		first_name?: string;
		last_name?: string;
		phone?: string;
	}
	access_level:[];
}

interface Organization {
	name: string;
}

export interface AnimalActivityResponse{
  all_data: AllDaum[]
  status: string
}

export interface AllDaum {
  metadata_list: MetadataList[]
}

export interface MetadataList {
  key_value: string
  sort_order: number
}